<template>
  <router-view v-if="routerAlive"></router-view>
</template>

<script>

export default {
  data () {
    return {
      routerAlive: true
    }
  },
  computed: {

  },
  created () {

  },
  methods: {
    async reloadMicroSite () {
      this.routerAlive = false
      await this.$nextTick()
      this.routerAlive = true
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
